import cls from "classnames";
import ArrowRight from "images/chevron-right.svg?react";
import ArrowLeft from "images/chevron-left.svg?react";
import LibraryObjectViewType from "../../../LibraryObjectCard/LibraryObjectViewType";
import LibraryObjectCard from "./../../../LibraryObjectCard/LibraryObjectCard";
import { LibraryCommonListTypes } from "../../LibraryCommonListPanel";
import classnames from "classnames";
import { useEffect, useState } from "react";
import { isUserStudent } from "services/users/utils";
import { LibraryObjectType } from "services/content/model";
import { routes } from "pages/routes";
import { useNavigate } from "react-router-dom";
import Paywall from "components/Paywall";
import { useUser } from "contexts/UserContext";
import { HStack } from "components/Stack";
import { useTranslation } from "react-i18next";
import Carousel, { useCarousel } from "components/Carousel/Carousel";

import "./LibraryCommonList.css";

const MIN_LARGE_SCREEN_WIDTH = 1200;

const LibraryCommonList = props => {
  const { t } = useTranslation();
  const carousel = useCarousel();
  const [isOpenPlanUpgradeModal, setIsOpenPlanUpgradeModal] = useState(false);
  const navigate = useNavigate();
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const hasProAccess = useUser(true).student?.access.pro_content;

  const isLargeScreen = windowSize.width > MIN_LARGE_SCREEN_WIDTH;

  useEffect(() => {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (Math.ceil(props.objects.length / 9) < props.page) {
      props.fetchMore && props.fetchMore();
    }
    // eslint-disable-next-line
  }, [props.page]);

  let objects = null;
  let isChapterList = props.objects.some(i => i.type === LibraryObjectType.LESSON);
  if (props.objects && props.objects.length > 0) {
    objects = props.objects.map(object => {
      let actionName = null;

      if (props.actionName) {
        actionName = props.actionName;
      } else if (object.type === LibraryObjectType.COURSE) {
        actionName = t("Learn.listPanel.viewCourse");
      } else if (object.type === LibraryObjectType.FOLDER) {
        actionName = t("Learn.listPanel.viewTopics");
      }

      return (
        <LibraryObjectCard
          isLocked={isUserStudent() && object.tier === "pro" && !hasProAccess}
          key={object.id}
          object={object}
          actionLabel={actionName}
          isProgress={props.isProgress}
          type={LibraryObjectViewType.LIST}
          listType={props.type}
          hasLesson={isChapterList}
          onOpenPlan={() => setIsOpenPlanUpgradeModal(true)}
        />
      );
    });
  }

  const handleClosePlan = () => {
    setIsOpenPlanUpgradeModal(false);
  };

  const showButtons = carousel.canPrev || carousel.canNext;
  const itemsPerView = isLargeScreen ? (props.itemsPerView ?? 3) : 1;

  return (
    <div className={cls("library-common-list", props.className)}>
      {isOpenPlanUpgradeModal && (
        <Paywall
          enable
          onUpgrade={() => navigate(routes.settingsBilling.path())}
          defaultOpen={isOpenPlanUpgradeModal}
          onClose={handleClosePlan}
          onSuccess={() => setIsOpenPlanUpgradeModal(false)}
        />
      )}

      {props.isRecommended ? (
        <HStack>
          {showButtons && (
            <div className="carousel-button-left">
              <div
                className={`carousel-button-item ${carousel.canPrev ? "" : "disabled"}`}
                onClick={carousel.prev}
              >
                <ArrowLeft />
              </div>
            </div>
          )}
          <div className="slider-recommended">
            <Carousel
              {...carousel.carouselProps}
              className="library-carousel"
              itemsPerView={1}
              gap={24}
            >
              {objects}
            </Carousel>
          </div>
          {showButtons && (
            <div className="carousel-button-right">
              <div
                className={`carousel-button-item ${carousel.canNext ? "" : "disabled"}`}
                onClick={carousel.next}
              >
                <ArrowRight />
              </div>
            </div>
          )}
        </HStack>
      ) : props.type === LibraryCommonListTypes.OBJECT && props.isSlide ? (
        <div className="slider">
          {showButtons && (
            <div className="carousel-button">
              <div
                className={`carousel-button-item ${carousel.canPrev ? "" : "disabled"}`}
                onClick={carousel.prev}
              >
                <ArrowLeft />
              </div>
              <div
                className={`carousel-button-item ${carousel.canNext ? "" : "disabled"}`}
                onClick={carousel.next}
              >
                <ArrowRight />
              </div>
            </div>
          )}

          <Carousel
            {...carousel.carouselProps}
            className="library-carousel"
            itemsPerView={itemsPerView}
            gap={24}
          >
            {objects}
          </Carousel>
        </div>
      ) : (
        <>
          <div
            className={classnames("list-style", {
              "is-topic": props.type === LibraryCommonListTypes.FOLDER,
            })}
          >
            {objects}
          </div>

          {props.type === LibraryCommonListTypes.FOLDER && (
            <div className="slider mobile is-topic">
              <div className="carousel-button">
                <div
                  className={`carousel-button-item ${carousel.canPrev ? "" : "disabled"}`}
                  onClick={carousel.prev}
                >
                  <ArrowLeft />
                </div>
                <div
                  className={`carousel-button-item ${carousel.canNext ? "" : "disabled"}`}
                  onClick={carousel.next}
                >
                  <ArrowRight />
                </div>
              </div>

              <Carousel
                {...carousel.carouselProps}
                className="library-carousel"
                itemsPerView={1}
                gap={24}
              >
                {objects?.reduce((wrappers, object, index) => {
                  return index % 2 && index < objects.length
                    ? [
                        ...wrappers,
                        <div
                          key={object.key}
                          className="object-card-wrapper folder-card-mobile-wrapper"
                        >
                          {object}
                          {objects[index + 1]}
                        </div>,
                      ]
                    : wrappers;
                }, [])}
              </Carousel>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default LibraryCommonList;
